/**
 * A view which displays a header and a content section.
 * @module app/views/PageInfoView
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
var PageInfoView = Backbone.View.extend({
  tagName: "p",

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {Boolean|String} options.header:false The initial markup to place in the header, or `false` to hide the header.
   * @param {String} options.content The main content.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      header: false,
      content: "",
    });
  },

  template: _.template(
    "<% if(header){%><span><%= header %></span><%}%>\n<%= content %>"
  ),

  render: function () {
    this.$el.html(this.template(this.options));
  },

  /**
   * Gets the header content.
   * @return {Boolean|String} The header content, or `false`, if the header is disabled.
   */
  getHeader: function () {
    return this.options.header;
  },

  /**
   * Gets the main content.
   * @return {String} The main content markup.
   */
  getContent: function () {
    return this.options.content;
  },

  /**
   * Sets the header content.
   * @param {Boolean|String} value The header content, or `false`, to hide the header.
   */
  setHeader: function (value) {
    var span = this.$("span").first();

    if (!span.length && value) {
      span = $("<span></span>").prependTo(this.$el);
    }

    span.html(value);

    if (!value) {
      span.remove();
    }

    this.options.header = value;
  },

  /**
   * Sets the main content markup.
   * @param {String} value The main content markup.
   */
  setContent: function (value) {
    var sp = this.$("span").first();

    this.$el.html(value);
    this.$el.prepend(sp);
    this.options.content = value;
  },
});

export default PageInfoView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/PageInfoView.js
// module id = 665
// module chunks = 1